var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms"},[_c('v-flex',{staticClass:"mb-3"},[_c('v-btn',{staticClass:"mx-0",attrs:{"color":"#0C2B4A","dark":""},on:{"click":function($event){return _vm.htmlToPaper('print')}}},[_vm._v("Print")])],1),_c('div',{attrs:{"id":"print"}},[(_vm.mersBranded)?_c('div',[_c('mersTerms')],1):_c('div',[_c('terms')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }